import Loader from '@/components/common/Loader';
import { Suspense } from 'react';
import ReviewContent from '../components/review/ReviewContent';

export default function TemplateReviewAwaitApprovalPage() {
  return (
    <Suspense fallback={<Loader />}>
      <ReviewContent hideDocumentActions />
    </Suspense>
  );
}
